import axiosInstance from "../axios/axiosInstance";
import { getActiveCompanyId } from "utils/companyContext";

const companyId = () => getActiveCompanyId();
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getMiscDeductions = async () => {
    const res = (await axiosInstance.get(`/companies/${companyId()}/post_tax_deductions/miscellaneous`)).data;
    return unwrap(res);
};

export const getMiscDeduction = async (id) =>
    (await axiosInstance.get(`/companies/${companyId()}/post_tax_deductions/miscellaneous/${id}`)).data;

export const createMiscDeduction = async (payload) =>
    (await axiosInstance.post(`/companies/${companyId()}/post_tax_deductions/miscellaneous`, payload)).data;

export const updateMiscDeduction = async ({ deductionId, ...payload }) =>
    (await axiosInstance.patch(`/companies/${companyId()}/post_tax_deductions/miscellaneous/${deductionId}`, payload)).data;

export const deleteMiscDeduction = async (deductionId) =>
    (await axiosInstance.delete(`/companies/${companyId()}/post_tax_deductions/miscellaneous/${deductionId}`)).data;

export const getChildSupportDeductions = async () => {
    const res = (await axiosInstance.get(`/companies/${companyId()}/post_tax_deductions/child_support`)).data;
    return unwrap(res);
};

export const getChildSupportDeduction = async (id) =>
    (await axiosInstance.get(`/companies/${companyId()}/post_tax_deductions/child_support/${id}`)).data;

export const createChildSupportDeduction = async (payload) =>
    (await axiosInstance.post(`/companies/${companyId()}/post_tax_deductions/child_support`, payload)).data;

export const updateChildSupportDeduction = async ({ deductionId, ...payload }) =>
    (await axiosInstance.patch(`/companies/${companyId()}/post_tax_deductions/child_support/${deductionId}`, payload)).data;

export const deleteChildSupportDeduction = async (deductionId) =>
    (await axiosInstance.delete(`/companies/${companyId()}/post_tax_deductions/child_support/${deductionId}`)).data;
